import type { StoreSearchResult } from '../../../types/api.types';

interface StatusCountCardsProps {
    stores: StoreSearchResult[];
}

export default function StatusCountCards({ stores }: StatusCountCardsProps) {
    const total = stores.length;
    const liveCount = stores.filter((s) => (s.storeStatus ?? 'Trial') === 'Active').length;
    const trialCount = stores.filter((s) => s.storeStatus === 'Trial').length;
    const inactiveCount = stores.filter((s) => s.storeStatus === 'Inactive').length;

    return (
        <div className="grid grid-cols-4 gap-4">
            {/* Total */}
            <div className="rounded-xl border border-[#e2e8f0] bg-white px-5 py-4">
                <p className="text-xs font-medium text-[#64748b] mb-1">Total Stores</p>
                <p className="text-2xl font-bold text-[#1e293b]">{total}</p>
            </div>

            {/* Live */}
            <div className="rounded-xl border border-[#bbf7d0] bg-[#f0fdf4] px-5 py-4">
                <div className="flex items-center gap-1.5 mb-1">
                    <span className="w-2 h-2 rounded-full bg-[#22c55e]" />
                    <p className="text-xs font-medium text-[#15803d]">Live</p>
                </div>
                <p className="text-2xl font-bold text-[#15803d]">{liveCount}</p>
            </div>

            {/* Trial */}
            <div className="rounded-xl border border-[#fde68a] bg-[#fffbeb] px-5 py-4">
                <div className="flex items-center gap-1.5 mb-1">
                    <span className="w-2 h-2 rounded-full bg-[#f59e0b]" />
                    <p className="text-xs font-medium text-[#92400e]">Trial</p>
                </div>
                <p className="text-2xl font-bold text-[#92400e]">{trialCount}</p>
            </div>

            {/* Inactive */}
            <div className="rounded-xl border border-[#e2e8f0] bg-[#f8fafc] px-5 py-4">
                <div className="flex items-center gap-1.5 mb-1">
                    <span className="w-2 h-2 rounded-full bg-[#94a3b8]" />
                    <p className="text-xs font-medium text-[#64748b]">Inactive</p>
                </div>
                <p className="text-2xl font-bold text-[#64748b]">{inactiveCount}</p>
            </div>
        </div>
    );
}
